/*
 *
 * Hedera Stablecoin SDK
 *
 * Copyright (C) 2023 Hedera Hashgraph, LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { EVM_ZERO_ADDRESS } from '../../../../../core/Constants.js';
import { lazyInject } from '../../../../../core/decorator/LazyInjectDecorator.js';
import { QueryHandler } from '../../../../../core/decorator/QueryHandlerDecorator.js';
import ContractId from '../../../../../domain/context/contract/ContractId.js';
import { RPCQueryAdapter } from '../../../../../port/out/rpc/RPCQueryAdapter.js';
import { MirrorNodeAdapter } from '../../../../../port/out/mirror/MirrorNodeAdapter.js';
import EvmAddress from '../../../../../domain/context/contract/EvmAddress.js';
import { ContractId as HContractId } from '@hashgraph/sdk';
import { GetTokenManagerListQuery, GetTokenManagerListQueryResponse, } from './GetTokenManagerListQuery.js';
let GetTokenManagerListQueryHandler = class GetTokenManagerListQueryHandler {
    constructor(queryAdapter, mirrorNode) {
        this.queryAdapter = queryAdapter;
        this.mirrorNode = mirrorNode;
    }
    async execute(command) {
        const { factoryId } = command;
        const contractInfo = await this.mirrorNode.getContractInfo(factoryId.toString());
        const res = await this.queryAdapter.getTokenManagerList(new EvmAddress(contractInfo.evmAddress));
        const removeDeletedAddress = await Promise.all(res
            .filter((item) => item !== EVM_ZERO_ADDRESS)
            .map(async (evmAddress) => {
            return (await this.mirrorNode.getContractInfo(evmAddress))
                .id;
        }));
        return Promise.resolve(new GetTokenManagerListQueryResponse(removeDeletedAddress.map((item) => ContractId.fromHederaContractId(HContractId.fromString(item)))));
    }
};
GetTokenManagerListQueryHandler = __decorate([
    QueryHandler(GetTokenManagerListQuery),
    __param(0, lazyInject(RPCQueryAdapter)),
    __param(1, lazyInject(MirrorNodeAdapter)),
    __metadata("design:paramtypes", [RPCQueryAdapter,
        MirrorNodeAdapter])
], GetTokenManagerListQueryHandler);
export { GetTokenManagerListQueryHandler };
